import { createSlice } from "@reduxjs/toolkit"
import commonApiSlice from "services/commonService"
import * as _ from "lodash"

const initialState = {
  departmentList: [],
  departmentListMap: {},
}

const slice = createSlice({
  name: "common",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addMatcher(
      commonApiSlice.endpoints.fetchDepartments.matchFulfilled,
      (state, action) => {
        state.departmentList = action.payload
        action.payload?.forEach((department) => {
          state.departmentListMap[department?._id] = department
        })
      }
    )

    builder.addMatcher(
      commonApiSlice.endpoints.fetchDepartments.matchRejected,
      (state, action) => {
        state.departmentList = []
        state.departmentListMap = {}
      }
    )
  },
})

export default slice.reducer
export const {} = slice.actions
